export default function _of(x) {
  return [x];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_of.js
// module id = 768
// module chunks = 1